import React from 'react'
import Loader from 'react-loader-spinner'
import formatNumber from '../../../../shared/utils/formatNumber'
import NotificationService from '../../../services/notification-service'
import { siteUrl } from '../../../utils/siteUrl'
import ProfileModal from '../../modals/profile-modal/profile-modal'
import PopupLogin from '../../molecules/popup-login/popup-login'
import MarketMenu from '../market-menu/market-menu'
import NavMenu from '../nav-menu/nav-menu'
import NotificationsMenu from '../notifications-menu/notifications-menu'
import './main-menu.scss'
import { useStaticQuery, graphql } from 'gatsby'

const MainMenu = props => {
  const {
    setCommondModal,
    setInfoUser,
    isLog,
    logStatus,
    redirectRegister,
  } = props

  const resultQuery = useStaticQuery(
    graphql`
      query MAIN_CHAT_BUTTON_QUERY {
        allContentfulNolPaises(filter: { node_locale: { eq: "es-CO" } }) {
          nodes {
            codigoIcu
            tieneTienda
            tieneMisPuntos
          }
        }
      }
    `
  )

  const haveShop = resultQuery.allContentfulNolPaises.nodes.filter(
    e => e.codigoIcu === process.env.LOCALE
  )[0].tieneTienda
  const havePoints = resultQuery.allContentfulNolPaises.nodes.filter(
    e => e.codigoIcu === process.env.LOCALE
  )[0].tieneMisPuntos

  var logoUrl = props.logoInfo.file.url
  var imgTitle = props.logoInfo.description
  var activeMenu = props.activeMenu
  const [activeCarrito, setActiveCarrito] = React.useState(false)
  const [activeNotificacion, setActiveNotificacion] = React.useState(false)
  const [thereAreNotification, setThereAreNotification] = React.useState(false)

  const registerRedirect = () => {
    window.location.href = redirectRegister()
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'trackEvent',
      eventCategory: 'ui :: ' + window.location.pathname,
      eventAction: 'click',
      eventLabel: 'regístrate',
    })
  }

  const contactRedirect = () => {
    window.location.href = siteUrl + '/contactanos/'
  }

  const loginRedirect = () => {
    window.location.href = siteUrl + '/login/'
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'trackEvent',
      eventCategory: 'ui :: ' + window.location.pathname,
      eventAction: 'click',
      eventLabel: 'iniciar sesión',
    })
  }

  const savedRedirect = () => {
    window.location.href = siteUrl + '/guardados/'
  }

  var homeLink = siteUrl + '/'
  var carritoLink = siteUrl + '/productos/tiendas/'

  const getAgeSegment = age => {
    if (age >= 9 && age <= 17) {
      return 'sara' //Sara
    } else if (age >= 18 && age <= 24) {
      return 'carolina' //carolina
    } else {
      return 'juliana' //juliana
    }
  }

  const calculateAge = () => {
    var today = new Date()
    var birthDate = new Date(
      JSON.parse(localStorage.getItem('USER_INFO')).birthdate
    )
    var age = today.getFullYear() - birthDate.getFullYear()
    var m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    return age
  }

  React.useEffect(() => {
    // setCommondModal(<ProfileModal setCommondModal={setCommondModal} logout={props.logout} setInfoUser={setInfoUser}/>)
    // setCommondModal(<OtpModal setCommondModal={setCommondModal}/>)
    if (localStorage.getItem('TOKEN_INFO') !== null) {
      const token = JSON.parse(localStorage.getItem('TOKEN_INFO')).idToken
      const config = {
        headers: {
          Authorization: token,
        },
      }
      const payload = {
        page: 0,
        size: 3,
        segment: getAgeSegment(calculateAge()),
      }
      NotificationService.getListNotifications(payload, config)
        .then(res => {
          if (res.status === 200) {
            if (res.data.unreadAmount && res.data.unreadAmount > 0) {
              setThereAreNotification(true)
            } else {
              setThereAreNotification(false)
            }
          }
        })
        .catch(e => console.warn(e))
    }
  }, [])

  const handleOpenProfileModal = () => {
    setCommondModal(
      <ProfileModal
        setCommondModal={setCommondModal}
        logout={props.logout}
        setInfoUser={setInfoUser}
      />
    )
  }

  //Desktop
  if (!props.mobile) {
    return (
      <>
        <nav className="f-nav-header-top">
          <a href={homeLink}>
            <img className={`f-logo`} src={logoUrl} alt={imgTitle} />
          </a>
          <div className="f-container f-container-header-top">
            <ul className="f-top-menu f-top-menu--left">
              <li>
                <a href={homeLink + 'buscador/'}>
                  <span className="icon-search f-icon f-search"></span>
                </a>
              </li>
              {haveShop && (
                <li>
                  <span
                    className="icon-cart f-icon f-btn-nav-cart"
                    onClick={() => {
                      if (activeCarrito) {
                        setActiveCarrito(false)
                      } else {
                        setActiveCarrito(true)
                      }
                    }}
                  ></span>
                  {activeCarrito && (
                    <MarketMenu
                      mobile={props.mobile}
                      activeCarrito={activeCarrito}
                      setActiveCarrito={setActiveCarrito}
                    />
                  )}
                </li>
              )}
              <li>
                <label
                  className="f-btn-nav-contact"
                  onClick={() => contactRedirect()}
                >
                  {process.env.LOCALE === 'es-AR' ||
                  process.env.LOCALE === 'es-PY' ||
                  process.env.LOCALE === 'es-UY'
                    ? 'Contactanos'
                    : 'Contáctanos'}
                </label>
              </li>

              <li className="f-last-item f-btn-nav-free-trial-notification">
                <span
                  className={
                    'icon-notification f-icon' +
                    (thereAreNotification ? ' f-icon-notification' : '')
                  }
                  onClick={() => {
                    const loging = localStorage.getItem('TOKEN_INFO')
                    if (loging) {
                      if (activeNotificacion) {
                        setActiveNotificacion(false)
                      } else {
                        setActiveNotificacion(true)
                      }
                    } else {
                      window.location.href = homeLink + 'login/'
                    }
                  }}
                ></span>
                {activeNotificacion && (
                  <NotificationsMenu
                    mobile={props.mobile}
                    activeNotificacion={activeNotificacion}
                    setActiveNotificacion={setActiveNotificacion}
                  />
                )}
              </li>
            </ul>
            <ul className="f-top-menu f-top-menu--right">
              {props.isLog && (
                <li onClick={() => savedRedirect()}>
                  <span className="icon-save f-icon f-btn-save-icon"></span>
                </li>
              )}
              <li className="f-last-item">
                {logStatus === 'waiting' ? (
                  <Loader
                    type="TailSpin"
                    color="#FF409B"
                    height={50}
                    width={50}
                  />
                ) : props.isLog ? (
                  <div
                    className="f-user-info-container"
                    onClick={() => handleOpenProfileModal()}
                  >
                    <div className="f-name-points-container">
                      <label className="f-name-user">
                        {'¡Hola, ' + props.infoUser.name.split(' ')[0] + '!'}
                      </label>
                      {havePoints && (
                        <label id="points-user" className="f-points-user">
                          {formatNumber(
                            props.infoUser.userPoints.pointsAccumulation +
                              props.infoUser.userPoints.pointsPresent
                          )}{' '}
                          PUNTOS
                        </label>
                      )}
                    </div>
                    <div className="f-avatar-img-container">
                      <img
                        className="f-avatar-img"
                        src={props.infoUser.profilePicture}
                        alt="Avatar imagen"
                      />
                    </div>
                    <span className="f-icon icon-down f-down-icon" />
                  </div>
                ) : (
                  <ul className="f-btn-group">
                    <li>
                      <button
                        className="f-btn f-btn-left"
                        onClick={() => loginRedirect()}
                      >
                        Iniciar sesión
                      </button>
                    </li>
                    <li>
                      <button
                        className="f-btn f-btn-right"
                        onClick={() => registerRedirect()}
                      >
                        {process.env.LOCALE === 'es-AR' ||
                        process.env.LOCALE === 'es-PY' ||
                        process.env.LOCALE === 'es-UY'
                          ? 'Registrate'
                          : 'Regístrate'}
                      </button>
                    </li>
                  </ul>
                )}
              </li>
            </ul>
          </div>
        </nav>
        <nav className="f-nav-header-bottom">
          <NavMenu
            mobile={props.mobile}
            navegationMenus={props.navegationMenus}
            navSubMenuTitles2={props.navSubMenuTitles2}
            navSubMenuTitles3={props.navSubMenuTitles3}
            navSubMenuTitles5={props.navSubMenuTitles5}
          />
        </nav>
      </>
    )
  } else {
    //Mobile
    return (
      <>
        <nav className="f-nav-header-mobile">
          <a href={homeLink} className={`f-logo-mobile`}>
            <img src={logoUrl} alt={imgTitle} />
          </a>

          <a href={homeLink + 'buscador/'} className="f-search-container">
            <span className="icon-search f-icon-search-mobile"></span>
          </a>

          {props.popupLogin && props.isLog && (
            <PopupLogin havePoints={!havePoints} infoUser={props.infoUser} />
          )}
          <ul className="f-main-menu-mobile">
            <a href={homeLink}>
              <li className="f-item-menu-mobile">
                <span className="icon-home f-icon-menu-mobile"></span>
                <label className="f-label-menu-mobile">Inicio</label>
              </li>
            </a>
            <li
              className={
                logStatus === 'waiting'
                  ? 'f-item-menu-mobile disable'
                  : 'f-item-menu-mobile'
              }
              onClick={
                !props.isLog
                  ? logStatus === 'waiting'
                    ? () => {}
                    : () => loginRedirect()
                  : () => handleOpenProfileModal()
              }
            >
              <span className="icon-profile f-icon-menu-mobile"></span>
              <label className="f-label-menu-mobile">Perfil</label>
            </li>
            {isLog && logStatus !== 'waiting' ? (
              <a href={homeLink + 'guardados/'}>
                <li
                  className={
                    logStatus === 'waiting'
                      ? 'f-item-menu-mobile disable'
                      : 'f-item-menu-mobile'
                  }
                >
                  <span className="icon-save f-icon-menu-mobile"></span>
                  <label className="f-label-menu-mobile">Guardados</label>
                </li>
              </a>
            ) : haveShop ? (
              <a href={carritoLink}>
                <li className="f-item-menu-mobile">
                  <span className="icon-cart f-icon-menu-mobile"></span>
                  <label className="f-label-menu-mobile">Tiendas</label>
                </li>
              </a>
            ) : null}
            <li
              className={
                logStatus === 'waiting'
                  ? 'f-item-menu-mobile disable'
                  : 'f-item-menu-mobile'
              }
            >
              <span
                className={
                  'icon-notification f-icon-menu-mobile' +
                  (thereAreNotification ? ' f-icon-notification-mobile' : '')
                }
                onClick={() => {
                  if (isLog) {
                    if (activeNotificacion) {
                      setActiveNotificacion(false)
                    } else {
                      setActiveNotificacion(true)
                    }
                  } else {
                    loginRedirect()
                  }
                }}
              ></span>
              <label className="f-label-menu-mobile">Notificaciones</label>
              {activeNotificacion && (
                <NotificationsMenu
                  mobile={props.mobile}
                  activeNotificacion={activeNotificacion}
                  setActiveNotificacion={setActiveNotificacion}
                />
              )}
            </li>

            <li
              onClick={() => {
                setInfoUser(JSON.parse(localStorage.getItem('USER_INFO')))
                props.changeMenu('main-nav')
              }}
              className="f-item-menu-mobile"
            >
              <span className="icon-menu f-icon-menu-mobile"></span>
              <label className="f-label-menu-mobile">Menú</label>
            </li>

            <NavMenu
              logout={props.logout}
              isLog={props.isLog}
              infoUser={props.infoUser}
              closeMenu={props.closeMenu}
              activeMenu={activeMenu}
              mobile={props.mobile}
              navegationMenus={props.navegationMenus}
              navSubMenuTitles2={props.navSubMenuTitles2}
              navSubMenuTitles3={props.navSubMenuTitles3}
              navSubMenuTitles5={props.navSubMenuTitles5}
              handleOpenProfileModal={handleOpenProfileModal}
            />
          </ul>
        </nav>
      </>
    )
  }
}

export default MainMenu
